module.exports = __webpack_public_path__ + "static/media/logo1.65587a02.png";